// // import {
// //   Box
// // } from "@chakra-ui/react";

// // import Sidebar from "../components/layout/Sidebar";
// // import { Outlet } from "react-router-dom";

// // export default function MainLayout() {

// //   return (
// //     <Box bg="#F8FAFC" minH="100vh">

// //       <Sidebar />

// //       <Box
// //         ml="260px"
// //         p={8}
// //       >
// //         <Outlet />
// //       </Box>

// //     </Box>
// //   );
// // }

// import {
//   Box
// } from "@chakra-ui/react";

// import {
//   useState
// } from "react";

// import Sidebar from "../components/layout/Sidebar";

// import {
//   Outlet
// } from "react-router-dom";

// export default function MainLayout() {

//   const [collapsed, setCollapsed] =
//     useState(false);

//   return (

//     <Box
//       bg="#F8FAFC"
//       minH="100vh"
//     >

//       <Sidebar
//         collapsed={collapsed}
//         setCollapsed={setCollapsed}
//       />

//       <Box
//         ml={collapsed ? "80px" : "260px"}
//         p={8}
//         transition="0.2s"
//       >
//         <Outlet />
//       </Box>

//     </Box>
//   );
// }

import { Box } from "@chakra-ui/react";
import { useState } from "react";
import Sidebar from "../components/layout/Sidebar";
import { Outlet } from "react-router-dom";

export default function MainLayout() {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <Box bg="#F8FAFC" minH="100vh">
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
      />

      <Box
        ml={collapsed ? "80px" : "260px"}
        p={8}
        transition="0.2s"
      >
        <Outlet />
      </Box>
    </Box>
  );
}